import { render, staticRenderFns } from "./BtDynamicTextFields.vue?vue&type=template&id=484470a0&"
import script from "./BtDynamicTextFields.vue?vue&type=script&lang=js&"
export * from "./BtDynamicTextFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports